export default function Efficacy() {
  return <div>TODO:Efficacy</div>;
}
